import { render, staticRenderFns } from "./SkuInfosList.vue?vue&type=template&id=4a4e029e&scoped=true&"
import script from "./SkuInfosList.vue?vue&type=script&lang=js&"
export * from "./SkuInfosList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4e029e",
  null
  
)

export default component.exports